import { Action } from '@ngrx/store';


import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SummaryInvestmentAssetMaterialModel } from '../../models/summary-investment-asset-material.model';


export enum InvestmentAssetMaterialActionTypes {
  LoadInvestmentAssetMaterials = '[InvestmentAssetMaterials] Load InvestmentAssetMaterials',
  LoadInvestmentAssetMaterialsSuccess = '[InvestmentAssetMaterials] Load InvestmentAssetMaterials Success',
  LoadInvestmentAssetMaterialsFailure = '[InvestmentAssetMaterials] Load InvestmentAssetMaterials Failure',

  LoadInvestmentAssetMaterial = '[InvestmentAssetMaterial] Load InvestmentAssetMaterial',
  LoadInvestmentAssetMaterialSuccess = '[InvestmentAssetMaterial] Load InvestmentAssetMaterial Success',
  LoadInvestmentAssetMaterialFailure = '[InvestmentAssetMaterial] Load InvestmentAssetMaterial Failure',

  CreateInvestmentAssetMaterial = '[InvestmentAssetMaterial] Create InvestmentAssetMaterial',
  CreateInvestmentAssetMaterialSuccess = '[InvestmentAssetMaterial] Create InvestmentAssetMaterial Success',
  CreateInvestmentAssetMaterialFailure = '[InvestmentAssetMaterial] Create InvestmentAssetMaterial Failure',

  UpdateInvestmentAssetMaterial = '[InvestmentAssetMaterial] Update InvestmentAssetMaterial',
  UpdateInvestmentAssetMaterialSuccess = '[InvestmentAssetMaterial] Update InvestmentAssetMaterial Success',
  UpdateInvestmentAssetMaterialFailure = '[InvestmentAssetMaterial] Update InvestmentAssetMaterial Failure',

  DeleteInvestmentAssetMaterial = '[InvestmentAssetMaterial] Delete InvestmentAssetMaterial',
  DeleteInvestmentAssetMaterialSuccess = '[InvestmentAssetMaterial] Delete InvestmentAssetMaterial Success',
  DeleteInvestmentAssetMaterialFailure = '[InvestmentAssetMaterial] Delete InvestmentAssetMaterial Failure',
}

/** Load all */

export class LoadInvestmentAssetMaterials implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterials;
  constructor(public payload: {filter: any}) {}
}

export class LoadInvestmentAssetMaterialsSuccess implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterialsSuccess;
  constructor(public payload: { items: SummaryInvestmentAssetMaterialModel[]; total: number }) {}
}

export class LoadInvestmentAssetMaterialsFailure implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterialsFailure;
  constructor(public payload: { error: any }) {}
}

/** Load by id */

export class LoadInvestmentAssetMaterial implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterial;
  constructor(public payload: { uid: string }) {}
}

export class LoadInvestmentAssetMaterialSuccess implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterialSuccess;
  constructor(public payload: SingleResponseModel<SummaryInvestmentAssetMaterialModel>) {}
}

export class LoadInvestmentAssetMaterialFailure implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterialFailure;
  constructor(public payload: { error: any }) {}
}

/** Create */

export class CreateInvestmentAssetMaterial implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.CreateInvestmentAssetMaterial;
  constructor(public payload: { investmentAsset: SummaryInvestmentAssetMaterialModel }) {}
}


export class CreateInvestmentAssetMaterialSuccess implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.CreateInvestmentAssetMaterialSuccess;
  constructor(public payload: { investmentAsset: SummaryInvestmentAssetMaterialModel }) {}
}

export class CreateInvestmentAssetMaterialFailure implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.CreateInvestmentAssetMaterialFailure;
  constructor(public payload: { error: any }) {}
}


/** Update */

export class UpdateInvestmentAssetMaterial implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.UpdateInvestmentAssetMaterial;
  constructor(public payload: { investmentAsset: SummaryInvestmentAssetMaterialModel }) {}
}

export class UpdateInvestmentAssetMaterialSuccess implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.UpdateInvestmentAssetMaterialSuccess;
  constructor(public payload: { investmentAsset: SummaryInvestmentAssetMaterialModel }) {}
}

export class UpdateInvestmentAssetMaterialFailure implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.UpdateInvestmentAssetMaterialFailure;
  constructor(public payload: { error: any }) {}
}


/** Delete */

export class DeleteInvestmentAssetMaterial implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.DeleteInvestmentAssetMaterial;
  constructor(public payload: { uid: string }) {}
}

export class DeleteInvestmentAssetMaterialSuccess implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.DeleteInvestmentAssetMaterialSuccess;
  constructor(public payload: { uid: string }) {}
}

export class DeleteInvestmentAssetMaterialFailure implements Action {
  readonly type = InvestmentAssetMaterialActionTypes.DeleteInvestmentAssetMaterialFailure;
  constructor(public payload: { error: any }) {}
}

export type InvestmentAssetMaterialActions =
  | LoadInvestmentAssetMaterials
  | LoadInvestmentAssetMaterialsSuccess
  | LoadInvestmentAssetMaterialsFailure
  | LoadInvestmentAssetMaterial
  | LoadInvestmentAssetMaterialSuccess
  | LoadInvestmentAssetMaterialFailure
  | CreateInvestmentAssetMaterial
  | CreateInvestmentAssetMaterialSuccess
  | CreateInvestmentAssetMaterialFailure
  | UpdateInvestmentAssetMaterial
  | UpdateInvestmentAssetMaterialSuccess
  | UpdateInvestmentAssetMaterialFailure
  | DeleteInvestmentAssetMaterial
  | DeleteInvestmentAssetMaterialSuccess
  | DeleteInvestmentAssetMaterialFailure
